module.exports = "/images/northern_cyprus.svg?be12fabb9050b3cb6a0514329dd8314c";